import { Stack } from '@mui/material'
import SectionTabRow from '@/components/SecondaryLeftNavigation/components/SectionTabRow'
import ThreadsSection from '@/components/SecondaryLeftNavigation/components/ThreadsSection'
import { Clock16Regular } from '@/components/Icon'
import styles from './HomeMainContentThreadsRail.module.scss'

export default function HomeMainContentThreadsRail({
  threads,
  selectedThreadId,
  onSelectThread,
  onThreadMenuAction,
  onRenameThread,
}) {
  return (
    <Stack className={styles.rail} direction="column" aria-label="Threads navigation">
      <SectionTabRow label="Threads" Icon={Clock16Regular} />
      <ThreadsSection
        threads={threads}
        selectedThreadId={selectedThreadId}
        onSelectThread={onSelectThread}
        onThreadMenuAction={onThreadMenuAction}
        onRenameThread={onRenameThread}
        showSectionTabRow={false}
      />
    </Stack>
  )
}
